module.exports = __webpack_public_path__ + "static/media/Zero.5b3a31eb.jpg";